import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.458 13a.755.755 0 0 1-.75.75h-4.73a.75.75 0 0 1 0-1.5h4.73a.749.749 0 0 1 .75.75Zm-6.02-1.37a15.306 15.306 0 0 1-2.32-3.08 3.084 3.084 0 0 1-.16-2.57 1.867 1.867 0 0 1 1.2-1.03.06.06 0 0 1 .04-.01 3.44 3.44 0 0 1-.03-.46c0-1.64 1.07-2.62 2.87-2.62h1.98a3.606 3.606 0 0 1 3.73 3.89 11.5 11.5 0 0 1-1.41 5.75.764.764 0 0 1-.64.36h-4.72a.782.782 0 0 1-.54-.23Zm-.97-3.73a12.488 12.488 0 0 0 1.84 2.46h3.94a10.66 10.66 0 0 0 1-4.61 2.123 2.123 0 0 0-2.23-2.39h-1.98c-1.21 0-1.37.54-1.37 1.12a1.224 1.224 0 0 0 1.3 1.15h1.14a.75.75 0 0 1 0 1.5h-.76a.689.689 0 0 1 .03.08.75.75 0 1 1-1.44.42c-.31-1.07-1.1-1.32-1.38-1.24a.353.353 0 0 0-.23.21 1.653 1.653 0 0 0 .14 1.3Z';
const draw24px =
  'M16.89,21.63H8a.75.75,0,0,1,0-1.5h8.89a.75.75,0,0,1,0,1.5ZM20.08,8.29a19.78,19.78,0,0,1-2.56,10.09.77.77,0,0,1-.63.34H8a.75.75,0,0,1-.53-.22,27.14,27.14,0,0,1-4.25-5.4A4.9,4.9,0,0,1,2.9,9,2.77,2.77,0,0,1,4.75,7.43a2.71,2.71,0,0,1,.71-.09A4.31,4.31,0,0,1,5.25,6C5.25,3.38,7,1.87,10,1.87h3.73C17.58,1.87,20.08,4.39,20.08,8.29Zm-1.5,0a4.54,4.54,0,0,0-4.85-4.92H10c-3.25,0-3.25,2-3.25,2.64,0,2,1.91,2.67,3.12,2.67H12a.75.75,0,0,1,0,1.5H9.64a6.29,6.29,0,0,1,.36.92.75.75,0,0,1-.5.94.76.76,0,0,1-.94-.49A4,4,0,0,0,7.13,9.4l-.21-.14a2.46,2.46,0,0,0-1.78-.38,1.26,1.26,0,0,0-.87.75,3.48,3.48,0,0,0,.29,2.8,24.55,24.55,0,0,0,3.75,4.79h8.14A19,19,0,0,0,18.58,8.29Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const GloveIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'glove'),
) as IconWithRender;

GloveIcon.displayName = 'GloveIcon';
GloveIcon.propTypes = Icon.propTypes;
GloveIcon.renderIcon = (props) => <GloveIcon {...props} />;
export default GloveIcon;
